import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { INSERT_TIMESHEET_APPROVAL } from "src/api-setup/api-endpoints";

export const insertTimesheetApproval = async (
  cookiesData,
  dispatch,
  selectedTimesheets,
  status,
  comment = ""
) => {
  if (!cookiesData || !selectedTimesheets || selectedTimesheets.length === 0) {
    return { data: null, error: "Invalid parameters" };
  }

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_timesheet_mstr_key: selectedTimesheets,
      in_approver_mstr_key: cookiesData.out_user_id.toString(),
      in_comment: comment,
      in_status: status,
    };

    const response = await POSTAPI(
      false,
      INSERT_TIMESHEET_APPROVAL,
      null,
      apiHeaders,
      requestBody,
      dispatch
    );

    return response;
  } catch (error) {
    console.error("Error in insertTimesheetApproval:", error);
    return { data: null, error: error.message };
  }
};

